export default function H3(props) {
  return (
    <h3 className={`${props.className} text-xl font-medium`}>
      {props.children}
    </h3>
  )
}